import styled from 'styled-components';
import { breakpoints, colors } from 'components/Theme';
import { asRem } from 'utils';

export default styled.div`
  margin-top: ${({ hasNotification }) => (hasNotification ? asRem(150) : asRem(80))};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: ${colors.black.c500};
  color: ${colors.white.c500};
  position: relative;
  padding: 0 !important;
  z-index: 100;
  cursor: pointer;

  @media (min-width: ${breakpoints.md}) {
    padding: ${asRem(20)} 0 0;
    margin-top: ${({ hasNotification }) => (hasNotification ? asRem(120) : asRem(80))};
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    @media (min-width: ${breakpoints.md}) {
      flex-direction: row;
    }

    .text-wrapper {
      margin: 0 ${asRem(24)};
      flex: 2;
      padding: ${asRem(25)} 0 0;

      @media (min-width: ${breakpoints.md}) {
        margin: 0;
      }
    }

    .wrapper {
      display: none;
      flex: 0;
      align-items: flex-end;
      height: ${asRem(115)};

      @media (min-width: ${breakpoints.md}) {
        display: flex;
      }
    }

    .balloonie {
      justify-content: flex-end;
    }

    .mountain {
      justify-content: flex-start;
    }

    .bf_balloonie {
      height: ${asRem(100)};
    }

    .bf_mountain {
      height: ${asRem(80)};
    }
  }

  .bf_mobile_images {
    display: flex;
    height: ${asRem(95)};
    margin-top: -${asRem(15)};

    @media (min-width: ${breakpoints.md}) {
      display: none;
    }
  }

  .mime-elements-headline-2 {
    margin-bottom: ${asRem(4)};
  }

  .mime-elements-paragraph {
    margin-bottom: ${asRem(24)};
  }
`;
